import { ItemRateTableNameBase } from './base/item-rate-table-name-base';

export class ItemRateTableName extends ItemRateTableNameBase { }